import produce from 'immer'

import { EInvoiceDto } from '../../../../data/models'
import type { FileMetaData } from '../../../../data/models/_generatedUblInvoice'

interface Payload extends Omit<EInvoiceDto, 'IssueDate' | 'Meta'> {
  IssueDate: {
    Value: Date
  }
  Meta: Omit<EInvoiceDto['Meta'], 'file'> & {
    file: Omit<FileMetaData, 'uploadedAt'> & {
      uploadedAt: Date
    }
  }
}
interface ConvertedEInvoiceResponse extends Omit<EInvoiceDto, 'Payload'> {
  Payload: Payload
}

/**
 * Converts a list of EInvoices responses into a list of converted EInvoice objects.
 *
 * This function uses the Immer library to create a new array of converted order objects from
 * the provided EInvoice array. The conversion process involves:
 *
 * 1. Checking if any data exists (returns empty array if no data).
 * 2. Transforming date strings into Date objects for easier filtering and sorting in tables.
 *
 * @param {WebEdiDto<OrderResponse | DespatchAdvice | Invoice>[] | undefined} responses - The list of responses to be converted.
 * @returns {ConvertedResponse[]} - The list of converted responses or an empty array if undefined.
 */
export function convertEInvoiceDates(responses: EInvoiceDto[] | undefined) {
  if (!responses) return []

  const convertedEInvoiceResponses = produce(responses, draft => {
    draft?.forEach(response => {
      // uploadedAt
      if (response.Meta?.file.uploadedAt) {
        const meta = response.Meta as any
        meta.file.uploadedAt = new Date(meta.file.uploadedAt)
      }

      // IssueDate
      const payload = response.Payload as any
      payload.IssueDate.Value = new Date(payload.IssueDate.Value)
    })
  }) as unknown as ConvertedEInvoiceResponse[]

  return convertedEInvoiceResponses
}
